/**
 * This module provides convenience helpers for determining which key was
 * pressed inside of a Keyboard Event handler.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 */
var WEBOS_ESCAPE = 461; // Some older versions of browsers return different names for the same key.
// That's why some of these are arrays

var BACKSPACE = 'Backspace';
var ENTER = ['Enter', 13];
var SPACE = [' ', 'Spacebar'];
var TAB = 'Tab';
var DOWN_ARROW = ['ArrowDown', 'Down', 40];
var LEFT_ARROW = ['ArrowLeft', 'Left', 37];
var RIGHT_ARROW = ['ArrowRight', 'Right', 39];
var UP_ARROW = ['ArrowUp', 'Up', 38];
var ESCAPE = ['Esc', 'Escape', 'XF86Back', 27, WEBOS_ESCAPE];
var MEDIA_FAST_FORWARD = ['MediaFastForward', 417];
var MEDIA_PAUSE = ['MediaPause', 19];
var MEDIA_PLAY = ['MediaPlay', 415];
var MEDIA_PLAY_PAUSE = ['MediaPlayPause', 179];
var MEDIA_REWIND = ['MediaRewind', 412];

var checkKey = function checkKey(key, keyNames) {
  if (!key) {
    return false;
  }

  if (keyNames.length > 0) {
    return keyNames.includes(key);
  }

  return false;
};

var checkEvent = function checkEvent(event) {
  var key = event.key;
  var code;

  if (event instanceof KeyboardEvent) {
    code = event.code;
  }

  for (var _len = arguments.length, keyNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keyNames[_key - 1] = arguments[_key];
  }

  return checkKey(key, keyNames) || checkKey(code, keyNames) || checkKey(event === null || event === void 0 ? void 0 : event.keyCode, keyNames);
}; // Whitespace keys


export var isBackspaceKey = function isBackspaceKey(event) {
  return checkEvent(event, BACKSPACE);
};
export var isEnterKey = function isEnterKey(event) {
  return checkEvent.apply(void 0, [event].concat(ENTER));
};
export var isSpaceKey = function isSpaceKey(event) {
  return checkEvent.apply(void 0, [event].concat(SPACE));
};
export var isTabKey = function isTabKey(event) {
  return checkEvent(event, TAB);
}; // Arrow keys

export var isDownArrowKey = function isDownArrowKey(event) {
  return checkEvent.apply(void 0, [event].concat(DOWN_ARROW));
};
export var isLeftArrowKey = function isLeftArrowKey(event) {
  return checkEvent.apply(void 0, [event].concat(LEFT_ARROW));
};
export var isRightArrowKey = function isRightArrowKey(event) {
  return checkEvent.apply(void 0, [event].concat(RIGHT_ARROW));
};
export var isUpArrowKey = function isUpArrowKey(event) {
  return checkEvent.apply(void 0, [event].concat(UP_ARROW));
};
export var isArrowKey = function isArrowKey(event) {
  return checkEvent.apply(void 0, [event].concat(DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW, UP_ARROW));
}; // UI keys

export var isEscapeKey = function isEscapeKey(event) {
  return checkEvent.apply(void 0, [event].concat(ESCAPE));
}; // Media keys

export var isMediaFastForward = function isMediaFastForward(event) {
  return checkEvent.apply(void 0, [event].concat(MEDIA_FAST_FORWARD));
};
export var isMediaRewind = function isMediaRewind(event) {
  return checkEvent.apply(void 0, [event].concat(MEDIA_REWIND));
};
export var isMediaPlayPause = function isMediaPlayPause(event) {
  return checkEvent.apply(void 0, [event].concat(MEDIA_PLAY_PAUSE));
};
export var isMediaPlay = function isMediaPlay(event) {
  return checkEvent.apply(void 0, [event].concat(MEDIA_PLAY));
};
export var isMediaPause = function isMediaPause(event) {
  return checkEvent.apply(void 0, [event].concat(MEDIA_PAUSE));
};